import { FC, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon, Modal } from 'src/components';
import VideoSection from 'src/apps/ScenarioGeneric/WordDetails/VideoSection';
import { useLearnableMedia } from '../hooks/useLearnableMedia';
import * as S from './styles';

const msgs = defineMessages({
  openVideoAltText: {
    id: 'pronunciationBuddy_testCard_openNativeVideo',
    defaultMessage: 'Watch native speaker video',
  },
});

export const LearnableVideoButton: FC<{ learnableId: number }> = ({ learnableId }) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const { videoUrls } = useLearnableMedia(learnableId);

  if (videoUrls.length === 0) return null;

  return (
    <>
      <S.VideoButton
        type="button"
        onClick={() => setIsOpen(true)}
        aria-label={intl.formatMessage(msgs.openVideoAltText)}
      >
        <Icon name="videoLibraryFilled" />
      </S.VideoButton>
      {isOpen && (
        <Modal isOpen handleClose={() => setIsOpen(false)} darkCloseIcon>
          <S.VideoModalContent>
            <VideoSection videoUrls={videoUrls} />
          </S.VideoModalContent>
        </Modal>
      )}
    </>
  );
};
